import { jsx as _jsx } from "react/jsx-runtime";

function PrerenderStatusCode({
  statusCode
}) {
  return /*#__PURE__*/_jsx("meta", {
    name: "prerender-status-code",
    content: `${statusCode}`
  });
}

export default PrerenderStatusCode;